import styled from 'styled-components';
import SistemaList from '~/pages/Sistema/componentes/SistemaList';

export const Main = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: auto;

  .content {
    padding: 0em 1em 2em 1em;
  }
`;

export const Container = styled(SistemaList)``;
